import React from 'react'
import { BackToList, VotesMode } from './../types'
import style from './BackToListButton.module.scss'
import Icon, { IconType } from '../../Icon'

const BackToListButton: React.FC<BackToList> = ({ setMode }) => {

  return (

      <div className={ style['back-to-list'] }>
        <a className={ style['back-to-list-link'] }
           onClick={ () => setMode({ mode: VotesMode.LIST }) }>
          <Icon
            className={ style['back-to-list-icon'] }
            name={ IconType.iconName.chevronLeft }
            colour={ IconType.colour.brightTALKDark }/>
          Back to list
        </a>
      </div>
  )
}

export default BackToListButton
